module.exports = __webpack_public_path__ + "static/img/XA.d3951536.svg";